function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_21523)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.59492 16.3044V9.77271H6.07593V8.10183H9.64555V16.3044H7.59492ZM17.4683 10.2284C17.4683 10.912 17.0886 11.5955 16.405 11.8993C17.3164 12.279 17.8481 13.0385 17.8481 13.9499C17.8481 15.393 16.5569 16.3803 14.5063 16.3803C12.4557 16.3803 11.1645 15.4689 11.1645 14.0259C11.1645 13.1145 11.7721 12.279 12.6835 11.8993C12 11.5195 11.5443 10.836 11.5443 10.1525C11.5443 8.86132 12.6835 8.02588 14.4304 8.02588C16.3291 8.02588 17.4683 8.86132 17.4683 10.2284ZM13.1392 13.798C13.1392 14.4816 13.5949 14.8613 14.5063 14.8613C15.4177 14.8613 15.8734 14.4816 15.8734 13.798C15.8734 13.1145 15.3418 12.7347 14.5063 12.7347C13.6709 12.7347 13.1392 13.1145 13.1392 13.798ZM13.3671 10.3044C13.3671 10.912 13.8228 11.2158 14.5823 11.2158C15.3418 11.2158 15.7974 10.912 15.7974 10.3044C15.7974 9.69676 15.3418 9.39297 14.5823 9.39297C13.8228 9.39297 13.3671 9.69676 13.3671 10.3044Z",
  fill: "#AEAED2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.3418 9.01325C21.7215 10.0006 21.8734 11.0639 21.8734 12.2031C21.8734 17.6715 17.4684 22.0765 12 22.0765C6.53165 22.0765 2.12658 17.6715 2.12658 12.2031C2.12658 6.73477 6.53165 2.32971 12 2.32971C13.0633 2.32971 14.1266 2.48161 15.1899 2.86135V0.658821C14.1266 0.355024 13.0633 0.203125 12 0.203125C5.39241 0.203125 0 5.59553 0 12.2031C0 18.8107 5.39241 24.2031 12 24.2031C18.6076 24.2031 24 18.8107 24 12.2031C24 11.1398 23.8481 10.0765 23.5443 9.01325H21.3418Z",
  fill: "#AEAED2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.8101 3.39298V1.1145H19.1393V3.39298H16.8608V5.06387H19.1393V7.34235H20.8101V5.06387H23.0886V3.39298H20.8101Z",
  fill: "#AEAED2"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_21523"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0 0.203125)"
})));

var SvgFooterLogo18 = function SvgFooterLogo18(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFooterLogo18, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/footer-logo-18.672464d3.svg";
export { ForwardRef as ReactComponent };